module.exports = __webpack_public_path__ + "static/media/p4.6f3612c3.jpg";